import { CountryField } from '@shared/fields/country-field';
import type { TDynamicFilterProps } from '../filter-popover-content/dynamic-filters/dynamic-filter-value-input';

export function DynamicCountryFilter({
  values,
  addOrEditDynamicFilter,
  onChange,
}: TDynamicFilterProps) {
  const selectedValue = values[0];

  return (
    <CountryField
      onSelect={(c) => {
        addOrEditDynamicFilter([c.name]);
        onChange([c.name]);
      }}
      isSelected={(c) => selectedValue === c.code}
      value={selectedValue}
      isInModal
    />
  );
}
